var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('about-us-section',{attrs:{"section":_vm.section,"section-class":_vm.sectionClasses}},[_c('template',{slot:"content"},[_c('img',{attrs:{"src":_vm.section.image,"alt":""}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }